"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestionsList = exports.SuggestionLabel = exports.Suggestion = exports.Spinner = exports.SearchInput = exports.SearchContainer = exports.RecentSectionLabel = exports.RecentSectionHeader = exports.LocationSearchIcon = exports.LocationSearchButton = exports.LiveRegion = exports.InputWrapper = exports.Hr = exports.Highlight = exports.ErrorState = exports.EmptyState = exports.ClearRecentsButton = exports.ClearInputButton = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const searchIconGray_svg_1 = __importDefault(require("../../../assets/icons/searchIconGray.svg"));
const colors_1 = require("../../../assets/styles/colors");
const media_1 = require("../../../utils/media");
const Suggestion = styled_components_1.default.li `
  cursor: pointer;
  padding: 0.8rem 0.8rem;
  min-height: 4.4rem;
  display: flex;
  align-items: center;
  font-size: 1.6rem;
  color: ${colors_1.gray400};
  border-radius: 4px;
  background-color: ${(p) => p.$isHighlighted ? `rgba(0, 178, 239, 0.08)` : `transparent`};

  &:hover {
    background-color: rgba(0, 178, 239, 0.08);
  }

  @media ${media_1.media.mediumDesktop} {
    min-height: 3.6rem;
    padding: 0.5rem 0.8rem;
  }
`;
exports.Suggestion = Suggestion;
const SuggestionLabel = styled_components_1.default.span `
  flex: 1;
  min-width: 0;
  line-height: 1.3;
  word-break: break-word;
`;
exports.SuggestionLabel = SuggestionLabel;
const LiveRegion = styled_components_1.default.div `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
exports.LiveRegion = LiveRegion;
const SuggestionsList = styled_components_1.default.ul `
  background-color: ${(p) => (p.$displaySearchResults ? `${colors_1.white}` : `none`)};
  position: absolute;
  top: 20%;
  list-style: none;
  left: 0;
  border: none;
  border-radius: 20px;
  box-shadow: ${(p) => p.$displaySearchResults ? `2px 2px 4px 0px rgba(76, 86, 96, 0.1)` : `none`};
  padding: 30px 0 8px 8px;
  width: 19rem;
  z-index: 2;
  color: ${colors_1.gray400};

  @media ${media_1.media.smallMobile} {
    width: 20rem;
  }

  @media ${media_1.media.smallDesktop} {
    width: 26rem;
  }

  @media ${media_1.media.mediumDesktop} {
    padding: 10px 0 8px 8px;
    border-radius: 0px 0px 10px 10px;
    top: 100%;
    z-index: 1;
  }
  @media ${media_1.media.largeDesktop} {
    width: 36.8rem;
  }
`;
exports.SuggestionsList = SuggestionsList;
const InputWrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  align-items: center;
`;
exports.InputWrapper = InputWrapper;
const SearchInput = styled_components_1.default.input `
  width: 19rem;
  height: 3.2rem;
  border-radius: ${(p) => p.$displaySearchResults ? `15px 15px 0px 0px` : `20px`};
  border: none;
  box-shadow: ${(p) => p.$displaySearchResults
    ? `0px 2px 0px 0px rgba(76, 86, 96, 0.1)`
    : `2px 2px 4px 0px rgba(76, 86, 96, 0.1)`};
  background: ${colors_1.white} url(${searchIconGray_svg_1.default}) 12px center no-repeat;
  background-size: 16px;
  font-size: 1.6rem;
  padding-left: 3.8rem;
  padding-right: 3.2rem;
  outline: none;
  z-index: 3;
  color: ${colors_1.gray400};

  @media ${media_1.media.smallMobile} {
    width: 20rem;
  }

  @media ${media_1.media.smallDesktop} {
    width: 26rem;
  }

  @media ${media_1.media.mediumDesktop} {
    height: 4.2rem;
    font-size: 1.6rem;
    padding: 0 1.6rem;
    border-radius: 50px;
    border: ${(p) => p.$displaySearchResults ? `none` : `1px solid ${colors_1.gray500}`};
    background: ${colors_1.white} url(${searchIconGray_svg_1.default}) 16px center no-repeat;
    background-size: 20px;
    padding-left: 4.8rem;
    padding-right: 4rem;
    box-shadow: none;
  }

  @media ${media_1.media.largeDesktop} {
    width: 36.8rem;
  }
`;
exports.SearchInput = SearchInput;
const LocationSearchButton = styled_components_1.default.button `
  background-color: ${colors_1.white};
  height: 4.4rem;
  min-width: 4.4rem;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  z-index: 2;

  &:focus-visible {
    outline: 2px solid ${colors_1.acBlue};
    outline-offset: 2px;
  }

  @media ${media_1.media.mediumDesktop} {
    height: 4.2rem;
    background-color: transparent;
  }
`;
exports.LocationSearchButton = LocationSearchButton;
const LocationSearchIcon = styled_components_1.default.img `
  width: 4rem;
  height: 4rem;

  @media ${media_1.media.mediumDesktop} {
    width: 4.2rem;
    height: 4.2rem;
  }
`;
exports.LocationSearchIcon = LocationSearchIcon;
const SearchContainer = styled_components_1.default.div `
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 70vw;

  @media ${media_1.media.smallMobile} {
    gap: 1rem;
  }

  @media ${media_1.media.smallDesktop} {
    width: auto;
  }

  ${(props) => props.$isTimelapseView &&
    `opacity: 0.7;
    pointer-events: none;`}
`;
exports.SearchContainer = SearchContainer;
const Hr = styled_components_1.default.hr `
  visibility: hidden;

  @media ${media_1.media.mediumDesktop} {
    visibility: ${(p) => (p.$displaySearchResults ? `visible` : `hidden`)};
    border-top: 1px solid ${colors_1.gray500};
    width: 97%;
  }
`;
exports.Hr = Hr;
const RecentSectionHeader = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.2rem 0.8rem 0.4rem 0.5rem;
`;
exports.RecentSectionHeader = RecentSectionHeader;
const RecentSectionLabel = styled_components_1.default.span `
  font-size: 1.2rem;
  font-weight: 600;
  color: ${colors_1.gray300};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;
exports.RecentSectionLabel = RecentSectionLabel;
const ClearRecentsButton = styled_components_1.default.button `
  background-color: transparent;
  color: ${colors_1.acBlueDark};
  border: none;
  font-size: 1.2rem;
  text-transform: uppercase;
  cursor: pointer;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${colors_1.acBlue};
    outline-offset: 2px;
  }
`;
exports.ClearRecentsButton = ClearRecentsButton;
const spin = (0, styled_components_1.keyframes) `
  from { transform: translateY(-50%) rotate(0deg); }
  to { transform: translateY(-50%) rotate(360deg); }
`;
const Spinner = styled_components_1.default.div `
  position: absolute;
  top: 50%;
  right: 1.2rem;
  transform: translateY(-50%);
  width: 1.6rem;
  height: 1.6rem;
  border: 2px solid ${colors_1.gray500};
  border-top-color: ${colors_1.acBlue};
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
  z-index: 4;
  pointer-events: none;
  box-sizing: border-box;

  @media ${media_1.media.mediumDesktop} {
    width: 2rem;
    height: 2rem;
    right: 1.6rem;
  }

  @media (prefers-reduced-motion: reduce) {
    animation-duration: 2s;
  }
`;
exports.Spinner = Spinner;
const ClearInputButton = styled_components_1.default.button `
  position: absolute;
  top: 50%;
  right: 1.2rem;
  transform: translateY(-50%);
  width: 2rem;
  height: 2rem;
  padding: 0;
  background: transparent;
  color: #888;
  border: none;
  font-size: 2.4rem;
  font-weight: 400;
  line-height: 1;
  cursor: pointer;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  @media ${media_1.media.mediumDesktop} {
    width: 2.4rem;
    height: 2.4rem;
    font-size: 2.8rem;
    right: 1.6rem;
  }

  &:hover {
    color: ${colors_1.gray350};
  }

  &:focus-visible {
    outline: 2px solid ${colors_1.acBlue};
    outline-offset: 2px;
    border-radius: 50%;
  }
`;
exports.ClearInputButton = ClearInputButton;
const EmptyState = styled_components_1.default.li `
  padding: 1.2rem 0.8rem;
  font-size: 1.4rem;
  color: ${colors_1.gray300};
  font-style: italic;
  list-style: none;
`;
exports.EmptyState = EmptyState;
const ErrorState = styled_components_1.default.li `
  padding: 1.2rem 0.8rem;
  font-size: 1.4rem;
  color: #b71c1c;
  list-style: none;
`;
exports.ErrorState = ErrorState;
const Highlight = styled_components_1.default.strong `
  font-weight: 700;
  color: ${colors_1.gray400};
`;
exports.Highlight = Highlight;
